import { render } from "./OnboardingSelectPage.vue?vue&type=template&id=0d0e153b"
import script from "./OnboardingSelectPage.vue?vue&type=script&lang=js"
export * from "./OnboardingSelectPage.vue?vue&type=script&lang=js"

import "../assets/css/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__